<template>
    <v-col cols="12" class="CardMaestro mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                 <v-row  >
                        <v-col>
                             <h2 class="font-weight-medium text-center title-reports my-6">Card Maestro</h2>
                        </v-col>
                       
                    </v-row>
                    <v-row>
                        <div class="mx-auto">
                         <v-card :key="'card-offers-add'"
                                            class="outline-0 py-12 px-3 text-center card-max-width overflow-hidden rounded-xl hover-outline-green "
                                            @click="showDialog('Crear')"
                                            color="#fff" min-height="515px">
                                        <v-row class="py-12">
                                            <v-col>
                                                <v-icon size="80">mdi-plus</v-icon>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <a href="#" class="">Agregar Nuevo </a>
                                            <v-btn
                                            class="mt-6"
                                         @click.stop="$refs.uploadFile.dialog.show = true"
                                           color="green"
                                           outlined
                                           
                                            ><v-icon>mdi-microsoft-excel</v-icon> Carga Masiva CSV</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                        </div>
                        <div class="mx-auto">
                            <v-card key="card-request-1"
                                    class="outline-0 py-6 px-3 card-max-width text-center overflow-hidden rounded-xl shadow-double"
                                    color="#FFF">

                                <v-img
                                        class="mx-auto blur"
                                        max-width="70%"
                                        alt="Neocity Logo"
                                        src="@/assets/images/neocity-logo.png"
                                        contain
                                ></v-img>
                            
                                <div class="mx-auto">
                                    <b>6 Meses</b>
                                </div>

                                    <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                <v-rating
                                        :value="'0'"
                                        readonly
                                        background-color="grey lighten-3"
                                        color="orange"
                                        >

                                </v-rating>
                               
                             
                                <template>
                                     <v-row>
                                        <v-col>
                                            <v-btn   class="ma-2" tile large color="grey" dense icon>
                                                <v-icon>mdi-check-box-outline</v-icon>
                                            </v-btn>
                                            <h6>Aprobar Cliente</h6>
                                        </v-col>
                                        <v-col>
                                            <v-btn  class="ma-2" tile large color="grey" dense icon>
                                                <v-icon>mdi-close-box-outline</v-icon>
                                            </v-btn>
                                            <h6>Rechazar Cliente</h6>
                                        </v-col>
                                    </v-row>
                                  
                                 
                                     
                                    <div  style="
                                    width: 0;
                                    right: 0;
                                    height: 0;
                                    border-style: solid;
                                    border-width: 0 60px 60px 0;
                                    border-color: transparent red transparent transparent;
                                    text-align: right;
                                    position: absolute;
                                    top: 0;"
                                    >
                                        <v-icon
                                                style=" margin-left: 30px; margin-top: 5px"
                                                color="white">mdi-close</v-icon>
                                    </div>
                                </template>
                                     
                                  <v-divider></v-divider>
                                         <v-col cols="1" class="mx-auto pa-0">
                                            <v-switch @click.stop="" class="pa-0" :value="true" ></v-switch>
                                        </v-col>
                                <a href="#" class="text-decoration-none">Ver detalles [ + ]</a>
                                 <v-divider></v-divider>
                                            <v-row class="align-center">
                                                <v-col>Enviar Solicitud</v-col>
                                                <v-col>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                    <h6>Aprobar Cliente</h6>
                                                </v-col>
                                                <v-col>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                    <h6>Rechazar Cliente</h6>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="justify-center text-center">
                                                    <a href="#" class="text-decoration-none">Ver detalles [ + ]</a>
                                                    <v-checkbox
                                                    style="width:45px"
                                                    class="mx-auto"
                                                    color="primary"
                                                    hide-details
                                                    ></v-checkbox>
                                                </v-col>
                                            </v-row>
                            </v-card>
                        </div>
                        <div class="mx-auto">
                            <v-card key="card-request-1"
                                    class="outline-0 py-6 px-3 card-max-width text-center overflow-hidden rounded-xl"
                                    color="#FFF">

                                <v-img
                                        class="mx-auto"
                                        max-width="70%"
                                        alt="Neocity Logo"
                                        src="@/assets/images/neocity-logo.png"
                                        contain
                                ></v-img>
                                <v-col class="mx-auto" cols="8">
                                    <b>
                                        A - 1000<br>
                                        X. Los Lagos, 220Kv<br>
                                        +50 MW
                                    </b>
                                </v-col>

                                <div class="mx-auto">
                                    <v-chip
                                            class="ma-2"
                                            color="#004E85"
                                            label
                                            text-color="white"
                                    >
                                        A
                                    </v-chip>
                                    <v-chip
                                            class="ma-2"
                                            color="#FF9A1B"
                                            label
                                            text-color="white"
                                    >
                                        B
                                    </v-chip>
                                    <v-chip
                                            class="ma-2"
                                            color="#0172C0"
                                            label
                                            text-color="white"
                                    >
                                        C
                                    </v-chip>
                                </div>
                                <div class="mx-auto">
                                    <b>6 Meses</b>
                                </div>

                                    <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                <v-rating
                                        :value="'4'"
                                        readonly
                                        background-color="orange lighten-3"
                                        color="orange"
                                        >

                                </v-rating>
                                <v-progress-linear 
                                class="mt-4"
                                    height="10px"
                                    color="green"
                                    value="90"></v-progress-linear>
                                     <v-progress-linear 
                                     class="mt-4"
                                    height="10px"
                                    color="orange"
                                    value="60"></v-progress-linear>
                                     <v-progress-linear 
                                     class="mt-4"
                                    height="10px"
                                    color="red"
                                    value="20"></v-progress-linear>
                                    <v-progress-linear 
                                    class="mt-4"
                                    height="10px"
                                    color="grey"
                                    value="0"></v-progress-linear>
                                                 
                                <v-col>
                                    <p><a href="#" class="text-decoration-none">Actualiza tu plan</a>
                                        para ver quienes son los interesados
                                    </p>
                                </v-col>
                                <template>
                                    <v-row>
                                        <v-col>
                                            <v-btn   class="ma-2" tile large color="green" dense icon>
                                                <v-icon>mdi-check-box-outline</v-icon>
                                            </v-btn>
                                            <h6>Aprobar Cliente</h6>
                                        </v-col>
                                        <v-col>
                                            <v-btn  class="ma-2" tile large color="red" dense icon>
                                                <v-icon>mdi-close-box-outline</v-icon>
                                            </v-btn>
                                            <h6>Rechazar Cliente</h6>
                                        </v-col>
                                    </v-row>
                                 
                                     <div  style="
                                    width: 0;
                                    right: 0;
                                    height: 0;
                                    border-style: solid;
                                    border-width: 0 60px 60px 0;
                                    border-color: transparent green transparent transparent;
                                    text-align: right;
                                    position: absolute;
                                    top: 0;"
                                    >
                                        <v-icon
                                                style=" margin-left: 30px; margin-top: 5px"
                                                color="white">mdi-check</v-icon>
                                    </div>
                                    
                                </template>
                                  <v-divider></v-divider>


                                        <div class="pt-6">
                                            <v-btn class="px-1"  text small color="primary">Editar</v-btn>
                                            <v-btn class="px-1"  @click.stop="" text small color="primary">Duplicar</v-btn>
                                            <v-btn  class="px-1" @click.stop="" text small color="primary">Eliminar</v-btn>
                                        </div>

                                  <v-divider></v-divider>
                                         <v-col cols="1" class="mx-auto pa-0">
                                            <v-switch @click.stop="" class="pa-0" :value="true" ></v-switch>
                                        </v-col>
                                <a href="#" class="text-decoration-none">Ver detalles [ + ]</a>

                                 <v-divider></v-divider>
                                        <div class="pt-6" @click.stop >
                                            <v-btn class="px-1"  text small color="primary">Editar</v-btn>
                                            <v-btn class="px-1"  text small color="primary">Eliminar</v-btn>
                                            <v-btn  class="px-1" text small color="green">Validar <v-checkbox color="green"></v-checkbox></v-btn>
                                            
                                        </div>
                            </v-card>
                        </div>
                    </v-row>

                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">

.v-expansion-panel{
    background: #F2F2F2 !important;
    border-radius: 4px;
}
.v-expansion-panel-content{
    border: 1px solid #F2F2F2;
    background-color: #ffffff !important;
    }


</style>
<script>
    export default {
        name: 'CardMaestro',
        created: function () {
            //this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>